// DO NOT EDIT -- generated from fs/services/dx-objects/bulkactions.proto

import { BulkArchiveDataTablesRequest, BulkArchiveDataTablesResponse } from './datatables.proto';
import { BulkArchiveFunnelsRequest, BulkArchiveFunnelsResponse } from './funnels.proto';
import { BulkArchiveHeatmapsRequest, BulkArchiveHeatmapsResponse } from './heatmaps.proto';
import { BulkArchiveJourneysRequest, BulkArchiveJourneysResponse } from './journeys.proto';
import { BulkArchiveMetricsRequest, BulkArchiveMetricsResponse } from './metrics.proto';
import { BulkArchiveRetentionMetricsRequest, BulkArchiveRetentionMetricsResponse } from './retentionmetrics.proto';
import { BulkArchiveSegmentsRequest, BulkArchiveSegmentsResponse } from './segments.proto';

export namespace BulkActionsPublic {

  export const BulkArchiveObjectsEndpoint = "/grpc/dx_objects.BulkActionsPublic/BulkArchiveObjects";
  export function BulkArchiveObjects(sender: (req: BulkArchiveObjectsRequest, endpoint: string) => Promise<BulkArchiveObjectsResponse>, req: BulkArchiveObjectsRequest): { promise: () => Promise<BulkArchiveObjectsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BulkArchiveObjectsEndpoint),
      endpoint: BulkArchiveObjectsEndpoint
    };
  }
}

export interface BulkArchiveObjectsRequest {
  orgId: string;
  funnels: BulkArchiveFunnelsRequest | null;
  heatmaps: BulkArchiveHeatmapsRequest | null;
  journeys: BulkArchiveJourneysRequest | null;
  metrics: BulkArchiveMetricsRequest | null;
  retentionMetrics: BulkArchiveRetentionMetricsRequest | null;
  segments: BulkArchiveSegmentsRequest | null;
  dataTables: BulkArchiveDataTablesRequest | null;
}

export interface BulkArchiveObjectsResponse {
  funnels: BulkArchiveFunnelsResponse | null;
  heatmaps: BulkArchiveHeatmapsResponse | null;
  journeys: BulkArchiveJourneysResponse | null;
  metrics: BulkArchiveMetricsResponse | null;
  retentionMetrics: BulkArchiveRetentionMetricsResponse | null;
  segments: BulkArchiveSegmentsResponse | null;
  dataTables: BulkArchiveDataTablesResponse | null;
}
